import { Button } from "@mui/material";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useGlobalContext } from "context/GlobalContext";
import React, { useState } from "react";

import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { useFinishContext } from "../context";
import { finishOperationsList } from "../constants/finish.constants";
import { FinishTopBanner } from "../components/FinishTopBanner";
import { addFinishApi } from "API/apis/finish/addFinish";

const initialState = {
  finishCode: "",
  finishDescription: "",
  companyId: 0,
};
export const AddFinish = () => {
  const { setError, setSuccess, setIsLoading } = useGlobalContext();
  const { setCurrentOperationPage, setReloadRequired } = useFinishContext();
  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleAddNewUserSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const { data, status } = await addFinishApi({ ...formData });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setFormData({ ...initialState });
      setReloadRequired(true);
      setCurrentOperationPage(finishOperationsList.listFinish);
      setSuccess(data?.message);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    }
  };
  return (
    <>
      <PageTitle pageName={pageName.enquiry.newEnquiry} />
      <FinishTopBanner
        buttonType="back"
        finishOperationsParam={finishOperationsList.listFinish}
      />
      <form onSubmit={handleAddNewUserSubmit}>
        <TextFieldWrapper
          id="finishCode"
          name="finishCode"
          label="Finish Code"
          variant="outlined"
          value={formData.finishCode}
          fullWidth
          required
          onChange={handleChange}
        />
        <TextFieldWrapper
          id="finishDescription"
          name="finishDescription"
          label="Finish Description"
          variant="outlined"
          value={formData.finishDescription}
          fullWidth
          required
          onChange={handleChange}
        />
        <Button variant="contained" type="submit" fullWidth>
          Submit
        </Button>
      </form>
    </>
  );
};
